import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('mermaid_cove', {
  cherry: 'starfish',
  lemon: 'conch_shell',
  orange: 'coral',
  bell: 'trident',
  star: 'mermaid_wild',
  seven: 'seahorse',
  gem: 'pink_pearl',
  scatter: 'singing_conch_scatter',
  money: 'mermaid_treasure',
});

/** Mermaid Cove — GENERATED by scaffoldSlot from
 *  content/slots/mermaid_cove.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const MERMAID_COVE_THEME: Theme = {
  id: 'mermaid_cove',
  name: 'Mermaid Cove',
  palette: {
    accent: 0x5bc6c6,
    secondary: 0xe89bb0,
    warm: 0xf3e1a8,
    frameFill: 0x12404a,
    bgGradientTop: 0x1c5a66,
    bgGradientBottom: 0x0a2a30,
    dimOverlay: 0x06181c,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Starfish', glyph: '⭐', tint: 0xe89bb0, weight: 5, textureAlias: 'mermaid_cove:cherry',
        winVideoAlias: 'mermaid_cove:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Conch Shell', glyph: '🐚', tint: 0xf0ddc4, weight: 5, textureAlias: 'mermaid_cove:lemon',
        winVideoAlias: 'mermaid_cove:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Coral', glyph: '🪸', tint: 0xf08858, weight: 4, textureAlias: 'mermaid_cove:orange',
        winVideoAlias: 'mermaid_cove:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Trident', glyph: '🔱', tint: 0xf0c860, weight: 3, textureAlias: 'mermaid_cove:bell',
        winVideoAlias: 'mermaid_cove:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Mermaid', glyph: '🧜‍♀️', tint: 0x5bc6c6, weight: 2, textureAlias: 'mermaid_cove:star',
        winVideoAlias: 'mermaid_cove:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Seahorse', glyph: '🦄', tint: 0xf3c84a, weight: 2, textureAlias: 'mermaid_cove:seven',
        winVideoAlias: 'mermaid_cove:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Pink Pearl', glyph: '🔮', tint: 0xf6dfe6, weight: 2.5, textureAlias: 'mermaid_cove:gem',
        winVideoAlias: 'mermaid_cove:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Singing Conch', glyph: '🐚', tint: 0xf0ddc4, weight: 0.5, textureAlias: 'mermaid_cove:scatter',
        winVideoAlias: 'mermaid_cove:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Mermaid Treasure', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'mermaid_cove:money',
        winVideoAlias: 'mermaid_cove:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x5bc6c6, multiplier: 1, weight: 5 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf3e1a8, multiplier: 2, weight: 4 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x5bc6c6, multiplier: 1, weight: 5 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xe89bb0, multiplier: 3, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf3e1a8, multiplier: 2, weight: 4 },
      { id: 'x1-c', kind: 'multiplier', label: '×1', tint: 0x5bc6c6, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf3e1a8, multiplier: 5, weight: 2 },
      { id: 'x2-c', kind: 'multiplier', label: '×2', tint: 0xf3e1a8, multiplier: 2, weight: 3 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0xe89bb0, multiplier: 3, weight: 3 },
      { id: 'x1-d', kind: 'multiplier', label: '×1', tint: 0x5bc6c6, multiplier: 1, weight: 4 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf3e1a8, multiplier: 5, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xf3e1a8, multiplier: 10, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'mermaid_cove:bg', path: 'environment/mermaid_cove.png' },
      columnBackground: { alias: 'mermaid_cove:column_bg', path: 'reel/mermaid_cove_column_bg.png' },
      border: { alias: 'mermaid_cove:border', path: 'brand/border_underwater.png' },
    },
  },
};
